import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { AppHeader } from './AppHeader'
import { AppDrawer } from './AppDrawer'
import { MobileNav } from './MobileNav'

export function Layout() {
  const [drawerOpen, setDrawerOpen] = useState(false)

  return (
    <div className="min-h-screen bg-gray-50 pb-safe-bottom">
      <AppHeader onMenuClick={() => setDrawerOpen(true)} />
      <AppDrawer open={drawerOpen} onOpenChange={setDrawerOpen} />

      {/* Main content with top padding for fixed header */}
      <main className="pt-14 pb-16 md:pb-8 mx-auto max-w-157.5 md:mt-4">
        <Outlet />
      </main>

      <MobileNav />
    </div>
  )
}
